import { DestroyRef, inject, Injectable } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { AbstractControl } from '@angular/forms';
import { Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, pairwise, startWith } from 'rxjs/operators';

export type RulesEngineInputs = {
  [key: string]: any;
};

@Injectable()
export class RulesEngineInputService {

  destroyRef = inject(DestroyRef);

  private _rulesEngineInputsChanged$ = new Subject<RulesEngineInputs>();

  rulesEngineInputsChanged = this._rulesEngineInputsChanged$.pipe(
    takeUntilDestroyed(this.destroyRef),
    distinctUntilChanged(),
  );

  private _rulesEngineInputs: RulesEngineInputs = {};

  private _controls = new Map<string, Subscription>();

  registerControl(control: AbstractControl, key: string): void {
    this._controls.get(key)?.unsubscribe();

    control['rulesEngineInput'] = true;

    const controlSub = control.valueChanges
      .pipe(
        startWith(control.value),
        takeUntilDestroyed(this.destroyRef),
        distinctUntilChanged(),
        debounceTime(100),
        pairwise()
      )
      .subscribe(([, value]) => {
        if (control['preventValidation']) {
          return;
        }

        this._rulesEngineInputs = {
          ...this._rulesEngineInputs,
          [key]: value,
        };

        if (!value) {
          delete this._rulesEngineInputs[key];
        }

        if (!this._rulesEngineInputs.productType) {
          return;
        }

        const hasProperties = !!Object.keys(this._rulesEngineInputs).length;
        const data = hasProperties ? control.root.value : null;

        if (data) {
          data.contextField = key?.split('.')?.pop() || key;
        }

        this._rulesEngineInputsChanged$.next(data);
      });

    this._controls.set(key, controlSub);
  }
}
